import styled from "@emotion/styled";
import { ContextButton, transparentWhite } from "@stepfinance/react";

import { ReactComponent as Cross } from "../../assets/cross.svg";
import { useLanguageContext } from "../../contexts/language/language";

export interface LoadingErrorMessageInterface {
  children: React.ReactNode;
  onRetryClick: () => void;
}

export const LoadingErrorMessage: React.FC<LoadingErrorMessageInterface> = ({ children, onRetryClick }) => {
  const {
    currentLanguageData: {
      components: { loadingErrorMessage },
    },
  } = useLanguageContext();

  return (
    <LoadingErrorMessageContainer>
      <Cross />
      <p className="error-loading-title">{children}</p>
      <ContextButton onClick={onRetryClick}>{loadingErrorMessage.retry}</ContextButton>
    </LoadingErrorMessageContainer>
  );
};

const LoadingErrorMessageContainer = styled.div`
  display: flex;
  align-items: center;

  .error-loading-title {
    color: ${transparentWhite};
    font-weight: 700;
    margin: 0;
    margin-left: 4px;
    margin-right: 8px;
  }
`;
